import React, { useState } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useDispatch, useSelector } from "react-redux";
import UpdatePassportRenewal from "./PopupUpdate/PopupUpdate";
import { useNavigate } from "react-router-dom";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import { CgSpinner } from "react-icons/cg";
import { useEffect } from "react";

export default function ListPassportRenwal({
  titles = [],
  // list = [],
  // updateData,
  token,
}) {
  
  const [Popup, setPopUp] = useState(false);

  const [editingIndex, setEditingIndex] = React.useState();
  const [searchWords, setSearchWords] = useState([]);

  const dispatch = useDispatch();

  const styles = {
    container: {
      position: "relative",
      width: "200px",
    },
    input: {
      width: "100%",
      height: "35px",
      padding: "10px",
      paddingRight: "30px", // Space for the icon
      fontSize: "16px",
      border: "1px solid #ccc",
      borderRadius: "3px",
      outline: "none",
    },
    tickIcon: {
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "18px",
      color: "green",
      cursor: "pointer",
    },
  };

  // const {
  //   NoDataFound,
  //   Pagination,
  //   PaginationIndex,
  //   Search,
  //   CountPerPage,
  //   currentList,
  // } = useSearchPagination(list?.data || []);

  const navigate = useNavigate();
  const apiCall = () => {
    // navigate(`/dashboard/fin-passport-renewal`);
    console.log("Payment to be done here");
  };
  const getInitialData = async () => {
    try {
      const response = await nodeinstance.get(`/passport-renewal/getAll`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        setSearchData(response.data.data);
      }
    } catch (error) {
      console.log("error to be seen in the console", error);
    }
  };
  
  const update = async (type) => {
    try {
      const res = await nodeinstance.post(
        "/passport-renewal/updatePayment/",
        type,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: "Employee status updated successfully.",
            color: "success",
          })
        );
        getInitialData();
        // updateData("");
        // onSearchClick();
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  const [searchData, setSearchData] = useState([]);
  //edit text Field
  const handleEdit = (index) => {
    setEditingIndex(index);
    setPopUp(searchData[index]); // Set the data for the popup
  };

  const [ApiKey, setApiKey] = useState("");
 
  useEffect(() => {
    getInitialData();
  }, []);
  const onSearchClick = async () => {
    if (ApiKey === "") {
      dispatch(
        setAppError({
          msg: "Serach filed should not be empty",
          // color: "success",
        })
      );
      return;
    }
    try {
      const response = await nodeinstance.get(
        `/passport-renewal/search/${ApiKey}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setSearchData(response.data.data);
      }
    } catch (error) {
      console.log("error to be seen in console", error);
    }
  };
  const onClearResponse = () => {
    setSearchData([]);
    setApiKey("");
    getInitialData();
  };
  const onSearchChange = (e) => {
    setApiKey(e.target.value);
  };
  return (
    <>
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse mt-3">
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => {
            onClearResponse();
          }}
        >
          <p>Clear filter</p>
        </button>
        <div style={styles.container}>
          <input
            type="text"
            placeholder="Enter text here"
            style={styles.input}
            value={ApiKey}
            onChange={(e) => {
              onSearchChange(e);
            }}
          />
          <span
            style={styles.tickIcon}
            onClick={() => {
              onSearchClick();
            }}
          >
            ✔️
          </span>
        </div>
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>

      {/* <CountPerPage /> */}
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh] ">
          <div className="sticky top-0 z-10 bg-white min-w-[1920px]">
            <div className="grid grid-cols-table-passport gap-5 p-6 text-center">
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-table-passport gap-5 p-6 bg-white text-center">
            {searchData.map((list, index) => (
              <React.Fragment key={index}>
                {/* <PaginationIndex index={index} /> */}
                <td className="px-6 whitespace-nowrap">{index + 1}</td>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.employee_id || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.name || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.client_name || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.iqama_number || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.passport_number || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.passport_expiry_date || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.passport_issue_date || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.nationality || "-"}
                  />
                </p>

                {list.NewPassportValodDays
                  ? list.NewPassportValodDays
                  : list.passport_valid_days
                    ? list.passport_valid_days
                    : "-"}
                <button
                  disabled={
                    // list.passport_status === "Completed" ||
                    list.passport_status === "Payment Pending" ? true : false
                  }
                  className={
                    list.passport_status === "Completed"
                      ? "bg-red px-2 rounded-md text-white text-xs p-2 w-40 "
                      : " bg-red px-2 rounded-md text-white text-xs p-2 w-40"
                  }
                  onClick={() => {
                    if (list.passport_status === "Payment Done") {
                      update({
                        employee_id: list.employee_id,
                        status: "Completed",
                      });
                    } else {
                      handleEdit(index);
                    }
                  }}
                >
                  {list.passport_status === "Passport Vaild" ||
                  list.passport_status === "Completed"
                    ? "Update"
                    : list.passport_status === "Payment Done"
                      ? "Update status to Passport renewal Done"
                      : list.passport_status}
                </button>
                <hr
                  className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      {/* <Pagination /> */}

      {/* Render UpdateForm component */}
      {Popup && editingIndex !== null && (
        <UpdatePassportRenewal
          data={Popup}
          setPopUp={setPopUp}
          onSuccess={apiCall}
        />
      )}
    </>
  );
}
